import {NgModule, OnInit} from '@angular/core';
import {Routes, RouterModule, Router} from '@angular/router';
import {AppComponent} from './app.component';
import {LandingpagePageComponent} from './pages/landingpage/components/landing-page/landingpage-page.component';
import {LandingpageModule} from './pages/landingpage/landingpage.module';
import {MitarbeiterverwaltungPageComponent} from './pages/Mitarbeiterverwaltung/components/mitarbeiterverwaltung-page/mitarbeiterverwaltung-page.component';
import {MitarbeiterverwaltungModule} from './pages/Mitarbeiterverwaltung/mitarbeiterverwaltung.module';
import {ZeiterfassungPageComponentModule} from './pages/Zeiterfassung/zeiterfassung.module';
import {ZeiterfassungPageComponent} from './pages/Zeiterfassung/components/zeiterfassung-page/zeiterfassung-page.component';
import {ProjektverwaltungPageComponent} from './pages/projektverwaltung/components/projekt-page/projektverwaltung-page.component';
import {ProjektverwaltungModule} from './pages/projektverwaltung/projektverwaltung.module';
import {AuswertungenPageComponentModule} from './pages/auswertungen/auswertungen.module';
import {AuswertungenPageComponent} from './pages/auswertungen/components/auswertungen-page/auswertungen-page.component';
import {HttpClient} from '@angular/common/http';
import {SecurityGuard} from './securityGuard';


const routes: Routes = [
  { path: 'landingpage', component: LandingpagePageComponent },
  { path: 'zeitverwaltung', component: ZeiterfassungPageComponent, canActivate: [SecurityGuard], data: {code: '3000'}},
  { path: 'mitarbeiterverwaltung', component: MitarbeiterverwaltungPageComponent, canActivate: [SecurityGuard], data: {code: '1000'} },
  { path: 'projektverwaltung', component: ProjektverwaltungPageComponent, canActivate: [SecurityGuard], data: {code: '2000'} },
  { path: '**', redirectTo: '/landingpage', pathMatch: 'full' },
];


@NgModule({
  // tslint:disable-next-line:max-line-length
  imports: [ MitarbeiterverwaltungModule , LandingpageModule, ZeiterfassungPageComponentModule, ProjektverwaltungModule, AuswertungenPageComponentModule, RouterModule.forRoot(  routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule{

}
